import React from 'react';

function ContactPage() {
    return (
        <div>
            {/* Page Title */}
            <section className="page-title">
                <div className="container">
                    <div className="row">
                        <div className="col col-xs-12">
                            <h2>Contact</h2>
                            <p>Gregor then turned to look out the window at the weather</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Section */}
            <section className="contact-section-s3 contact-pg-section section-padding">
                <div className="content-area clearfix">
                    <div className="contact-info-col">
                        <div className="contact-info">
                            <ul>
                                <li>
                                    <i className="fi flaticon-home-3"></i>
                                    <h4>Head Office</h4>
                                    <p>54, Dahs udin sorok, Melborn Austria</p>
                                </li>
                                <li>
                                    <i className="fi flaticon-email"></i>
                                    <h4>Email Address</h4>
                                    <p>demo@example.com</p>
                                </li>
                                <li>
                                    <i className="fi flaticon-support"></i>
                                    <h4>Telephone</h4>
                                    <p>654756175+5474</p>
                                </li>
                                <li>
                                    <i className="fi flaticon-clock"></i>
                                    <h4>Office Hour</h4>
                                    <p>Mon-Sun: 10am – 7pm</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="contact-form-col">
                        <div className="section-title-s2">
                            <div className="icon">
                                <i className="fi flaticon-balance"></i>
                            </div>
                            <span>Contact form</span>
                            <h2>Need Consultancy, <br />Request A Free Quote</h2>
                            <p>Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nuncIt showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy</p>
                        </div>

                        <div className="contact-form">
                            <form method="post" className="contact-validation-active" id="contact-form-main">
                                <div>
                                    <input type="text" className="form-control" name="name" id="name" placeholder="Name*" />
                                </div>
                                <div>
                                    <input type="email" className="form-control" name="email" id="email" placeholder="Email*" />
                                </div>
                                <div>
                                    <input type="text" className="form-control" name="phone" id="phone" placeholder="Phone*" />
                                </div>
                                <div>
                                    <select name="subject" className="form-control" defaultValue="">
                                        <option value="" disabled>Contact subject</option>
                                        <option value="Subject 1">Subject 1</option>
                                        <option value="Subject 2">Subject 2</option>
                                        <option value="Subject 3">Subject 3</option>
                                    </select>
                                </div>
                                <div className="fullwidth">
                                    <textarea className="form-control" name="note" id="note" placeholder="Case Description..."></textarea>
                                </div>
                                <div className="submit-area">
                                    <button type="submit" className="theme-btn">Submit It Now</button>
                                    <div id="loader">
                                        <i className="ti-reload"></i>
                                    </div>
                                </div>
                                <div className="clearfix error-handling-messages">
                                    <div id="success">Thank you</div>
                                    <div id="error"> Error occurred while sending email. Please try again later. </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Map */}
            <section className="contact-map-section">
                <h2 className="hidden">Contact map</h2>
                <div className="contact-map">
                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d193595.9147703055!2d-74.11976314309273!3d40.69740344223377!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew+York%2C+NY%2C+USA!5e0!3m2!1sen!2sbd!4v1547528325671" 
                        allowFullScreen
                        title="Google Maps Location"
                    ></iframe>
                </div>
            </section>
        </div>
    );
}

export default ContactPage;